import axios, { AxiosResponse, AxiosRequestConfig } from 'axios';
import { getToken } from '../app-utils';
import { SERVER_URL } from './process';

axios.defaults.baseURL = SERVER_URL;

export const makeRequestWithoutToken = {
  get: (endpoint: string, config?: AxiosRequestConfig): Promise<AxiosResponse> =>
    axios.get(endpoint, config),
  post: (endpoint: string, data: Record<string, any> = {}, config?: AxiosRequestConfig): Promise<AxiosResponse> =>
    axios.post(endpoint, data, config),
  put: (endpoint: string, data: Record<string, any> = {}, config?: AxiosRequestConfig): Promise<AxiosResponse> =>
    axios.put(endpoint, data, config),
  delete: (endpoint: string, config?: AxiosRequestConfig): Promise<AxiosResponse> =>
    axios.delete(endpoint, config),
  patch: (endpoint: string, data: Record<string, any> = {}, config?: AxiosRequestConfig): Promise<AxiosResponse> =>
    axios.patch(endpoint, data, config),
};

export const makeRequestWithToken = {
  get: (endpoint: string, params: Record<string, any> = {}, config?: AxiosRequestConfig): Promise<AxiosResponse> => {
    const defaultConfig: AxiosRequestConfig = {
      headers: {
        Authorization: `Bearer ${getToken()}`,
      },
      params,
    };

    const mergedConfig = config
      ? {
          ...defaultConfig,
          ...config,
          headers: {
            ...defaultConfig.headers,
            ...(config.headers || {}),
          },
        }
      : defaultConfig;

    return axios.get(endpoint, mergedConfig);
  },

  post: (endpoint: string, data: Record<string, any> = {}, config?: AxiosRequestConfig): Promise<AxiosResponse> => {
    const defaultConfig: AxiosRequestConfig = {
      headers: {
        Authorization: `Bearer ${getToken()}`,
      },
    };

    const mergedConfig = config
      ? {
          ...defaultConfig,
          ...config,
          headers: {
            ...defaultConfig.headers,
            ...(config.headers || {}),
          },
        }
      : defaultConfig;

    return axios.post(endpoint, data, mergedConfig);
  },

  put: (endpoint: string, data: Record<string, any> = {}, config?: AxiosRequestConfig): Promise<AxiosResponse> => {
    const defaultConfig: AxiosRequestConfig = {
      headers: {
        Authorization: `Bearer ${getToken()}`,
      },
    };

    const mergedConfig = config
      ? {
          ...defaultConfig,
          ...config,
          headers: {
            ...defaultConfig.headers,
            ...(config.headers || {}),
          },
        }
      : defaultConfig;

    return axios.put(endpoint, data, mergedConfig);
  },

  delete: (endpoint: string, config?: AxiosRequestConfig): Promise<AxiosResponse> => {
    const defaultConfig: AxiosRequestConfig = {
      headers: {
        Authorization: `Bearer ${getToken()}`,
      },
    };

    const mergedConfig = config
      ? {
          ...defaultConfig,
          ...config,
          headers: {
            ...defaultConfig.headers,
            ...(config.headers || {}),
          },
        }
      : defaultConfig;

    return axios.delete(endpoint, mergedConfig);
  },

  patch: (endpoint: string, data: Record<string, any> = {}, config?: AxiosRequestConfig): Promise<AxiosResponse> => {
    const defaultConfig: AxiosRequestConfig = {
      headers: {
        Authorization: `Bearer ${getToken()}`,
      },
    };

    const mergedConfig = config
      ? {
          ...defaultConfig,
          ...config,
          headers: {
            ...defaultConfig.headers,
            ...(config.headers || {}),
          },
        }
      : defaultConfig;

    return axios.patch(endpoint, data, mergedConfig);
  },
};